const speedDial = {
  quickCreate: "Quick Create",
  aiAssistant: "AI Assistant",
  search: "Search",
  newNote: "New Note",
  timer: "Timer",
  editMode: "Edit Mode",
  doneEditing: "Done Editing",
  pickShortcut: "Pick Shortcut",
  searchShortcuts: "Search...",
  pages: "Pages",
  widgets: "Widgets",
  entities: "Entities",
  longPressToEdit: "Long-press to edit",
  emptySlot: "Empty",
  removeSlot: "Remove",
} as const;
export default speedDial;
